import { createSelector } from 'reselect'
import { State } from './store.model'

export const getDatatable = (state: State) => state.datatable

export const getEndpoint = createSelector(getDatatable, (datatable) => datatable.endpoint)

export const getCol = createSelector(getDatatable, (datatable) => datatable.col)

export const getColByDataKey = (dataKey: string) =>
	createSelector(getCol, (cols) => cols?.filter((item) => item.dataKey === dataKey)[0])

export const getData = createSelector(getDatatable, (datatable) => datatable.data)

export const getPage = createSelector(getDatatable, (datatable) => datatable.page)

export const getActualPage = createSelector(getPage, (page) => page.actual)

export const getPagesCount = createSelector(getPage, (page) => page.count)

export const getShowFilter = createSelector(getDatatable, (page) => page.show.filter)

export const getShowFilterSwitch = createSelector(getDatatable, (page) => page.show.filterSwitch)

export const getShowPaginator = createSelector(getDatatable, (page) => page.show.paginator)

export const getShowMoreEnabled = createSelector(getDatatable, (page) => page.show.showMore)

export const getShowLimit = createSelector(getDatatable, (page) => page.show.limit)

export const getLimit = createSelector(getPage, (page) => page.limit)

export const getSort = createSelector(getDatatable, (datatable) => datatable.sort)

export const isSortAsc = (dataKey: string) =>
	createSelector(getSort, (sort) => sort[dataKey] && sort[dataKey] === 'asc')

export const isSortDesc = (dataKey: string) =>
	createSelector(getSort, (sort) => sort[dataKey] && sort[dataKey] === 'desc')

export const getPending = createSelector(getDatatable, (datatable) => datatable.pending)

export const getFilters = createSelector(getDatatable, (datatable) =>
	datatable.col.map((item) => (item.filter ? item.filter : [])).flat(),
)

export const getFilter = (dataKey: string) =>
	createSelector(getFilters, (filters) => filters.filter((item) => item.dataKey === dataKey)[0])

export const isFiltered = createSelector(getFilters, (filters) => filters.filter((item) => !!item.value).length)
